// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","container":"readMore_container__c9KKl","container__readOrHide":"readMore_container__readOrHide___sJYe"};